import './styles.sass'
import { NotificationHeader } from '@/components/Notification/StickyNotification/NotificationHeader'
import { NotificationMessageBody } from './NotificationMessageBody'
import { NotificationMessageSubject } from './NotificationMessageSubject'
import NotificationsService from '@/app-domains/user/session/notifications/NotificationService'
import threadsService from '@/app-domains/threads/threads.service'
import commonsService from '@/services/commons.service'
import { Button } from '@/components/Button/Button'

export function StickyNotification () {
  const thread = threadsService.getLastThread()
  const message = threadsService.getHeadMessageOfThread(thread)
  const text = message.text?.length > 140 ? `${message.text.slice(0, 140)} ...` : message.text

  function removeNotification () {
    NotificationsService.toggleNotificationVisibility(false)
  }

  async function removeMessage () {
    threadsService.setThreadDeleted(message.threadId, message, true, true)
    removeNotification()
  }

  return (
    <div className="sticky-notification-card">
      <NotificationMessageSubject subject={message.subject} removeNotification={removeNotification} />
      <NotificationHeader
          message={message}
        />
      <NotificationMessageBody text={text || ''} html={message.html}/>
      <div className="notifications-bottom">
        <div className="cancel">
          <Button type={'secondary'} content={'Delete'} click={removeMessage} />
        </div>
        <div>
          <Button content={'See message'} click={() => {
            commonsService.scrollToTopOfFeed()
          }} />
        </div>
      </div>
    </div>
  )
}
